// extracted by mini-css-extract-plugin
export default {"list":"N_4E2ICNSjxEIq8HtffR","emptyDescription":"_eAXBMkSGSayzeAJbDUh"};